<template>
  <div>
    <div class="back" @click="backpage">
      <i></i>
      <span>返回</span>
    </div>
    <div
      class="stepcontent"
      v-if="
        isActive !== 4 && isActive !== 5 && isActive !== 6 && isActive !== 8
      "
    >
      <div class="stepitem">
        <span v-if="$route.name != 'Testpapers'">1.创建考试</span>
        <span v-if="$route.name == 'Testpapers'">1.创建练习</span>
      </div>
      <div class="stepitem" :class="{ steptwo: isstepone && isActive != 9 }">
        <span>2.出题范围</span>
      </div>
      <div class="stepitem" :class="{ steptwo: issteptwo }">
        <span>3.题量及分数设置</span>
      </div>
      <div
        class="stepitem"
        :class="{ steptwo: isstepthree }"
        v-if="$route.name != 'Paperlist'"
      >
        <span v-if="$route.name != 'Testpapers'">4.考场/考生设置</span>
        <span v-if="$route.name == 'Testpapers'">4.考生设置</span>
      </div>
    </div>
    <div class="stepcontent" v-if="isActive == 4 || isActive == 5">
      <div class="stepitem">
        <span>1.出题范围</span>
      </div>
      <div class="stepitem" :class="{ steptwo: isstepfour !== 1 }">
        <span>2.题量及分数设置</span>
      </div>
    </div>
    <div class="konghuang"></div>
    <transition name="fade-transform">
      <keep-alive>
        <component
          :is="coms"
          :cutcoms="cutcoms"
          :cutcomsfour="cutcomsfour"
          :reducesum="reducesum"
          :testname="testname"
        ></component>
      </keep-alive>
    </transition>
  </div>
</template>

<script>
import qs from "qs";
import editqusetionbank from "@/api/editqusetionbank";
export default {
  data() {
    return {
      testname: "", //编辑后的试卷名称。
      reducesum: "", //计算得出的总分，在第四页需要。
      iseditmode: "", //编辑模式下的字段 新增模式下没有此字段，暂时通过有没有来判断。
      isnowstyle: "", //当前的试卷详情。
      SelectCpt: "", //最终需要保存的数据
      Style: {}, //最终需要保存的是
      CookieCpt: "", //最终需要保存的数据
      pagetwodata: "", //智能填题第二步请求过来的数据
      isActive: 0,
      isstepfour: 0,
      testinfomation: {}, //当前试卷的所有信息。
      paperinfomation: {},
      isselecttest: "", //当前选择的题型。
      plateType: "", // 编辑当前板块题型校验
      //   ismode:''//试卷组卷模式的选项情况。
      smartpagetwo: "", //智能编辑第二步的数据。
      examdata: "", //试卷统一，编辑按钮第一步选中的数据。
      random_db_data: {
        //智能随机
        editChangeScope: "", //智能随机编辑下 是否更改了范围，默认没有更改为空，更改了为true
        SelectCpt: [],
        CookieCpt: {},
        softApp: {}, //暂时不采用更改
        CookieApp: {}, //暂时不采用更改
        SelectedApp: {}, //暂时不采用更改
        Style: [],
      },
      random_Proportion_data: {
        //权重随机
        isaddnewselectChapter: { zhanwei: "" }, //临时数据，供第三步使用。
        pageStyelArr: [], //临时数据，供第三步使用。
        isaddnewscope: 0, //0是默认。1是新增
        isableoptions: {}, //临时数据，禁用
        SelectcharpterCpt: {}, //临时数据，全部勾选
        SelectedApp: [],
        qzHTML: "",
        SelectCpt: [],
        Style: [],
        CookieApp: {},
        CookieCpt: [],
        softApp: {},
        DroitArr: {},
        G_SlectedTestHt: {}, //暂时不采用更改
        tempSelectCptArray: [], //暂时不采用更改
      },
      random_exam_data: {
        //试卷随机
        pageStyelArr: [], //临时数据，供第三步使用。
        SelectCpt: [],
        Style: [],
        CookieCpt: {},
        softApp: {},
      },
      paper_data: {
        //试卷统一
        config: {},
        oldStyle: {},
      },
      israndom_Proportion: "", //是否是权重随机 1代表是
      isnewtestaas: 0, //是否是新增状态下如果是从第二步到第三步的，值为0就刷新，从第四步到第三步的，值为1就不刷新。
      addtopic: null, // 是否是难易度添题
    };
  },
  components: {
    Pageone: () => import("./components/pageone.vue"), //第一步
    smartPagetwo1: () => import("./components/smartpagetwo1.vue"), //第二部  智能统一进入这里
    smartPagetwo2: () => import("./components/smartpagetwo2.vue"), //第二部 智能随机进入这里
    smartPagetwo3: () => import("../newaddpaper/components/combinpagetwo.vue"), //试卷随机
    smartPagetwo4: () =>
      import("../../components/newaddpaper/components/weightRange.vue"), //权重随机第二步
    // Pagethree: () => import("./components/pagethree.vue"), //第三步题量和分数范围。
    Pagethree: () => import("../newaddpaper/components/pagethree.vue"),
    ThreeSon: () => import("./components/threeSon.vue"),
    Pagefour: () =>
      import("../../components/newaddpaper/components/pagefour.vue"), //第四步
    Addtestscope: () => import("./components/addtestscope.vue"), //智能统一切换到智能填题按钮的地方第一步页面
    Addscore: () => import("./components/addscore.vue"), //智能组卷添加按钮的第二部
    Addexamtest: () => import("./components/eaxmtest.vue"), //试卷统一切换到智能填题按钮的地方第一步页面
    Manualaddscore: () => import("./components/manualaddscore.vue"), //手动填题页面。
    HomePage: () => import("../page.vue"), // 首页
    replacetestdata: () => import("./components/replacepaper.vue"), //替换题目的页面
    replaceExamData: () => import("./components/replaceExamData.vue"),
    facilityPage: () =>
      import("../../components/newaddpaper/components/facilityPage.vue"),
  },
  computed: {
    ismode() {
      // console.log("组卷类型", this.testinfomation.PaperMode);
      //计算出题的类型。、
      switch (this.testinfomation.PaperMode) {
        case "unified_db":
          return "smartPagetwo1"; //智能组卷统一命题
        case "paper":
          return "smartPagetwo1"; //智能组卷统一命题
        case "random_db":
          return "smartPagetwo2"; //智能组卷随机命题
        case "unified_exam":
          return "smartPagetwo1"; //试卷统一
        case "sg_db":
          return "smartPagetwo1"; //精准手工
        case "unified_Proportion":
          return "smartPagetwo1"; //权重统一
        case "random_exam":
          return "smartPagetwo3"; //试卷随机
        case "random_Proportion":
          return "smartPagetwo4"; //权重随机
        case "unified_difflever":
          return "smartPagetwo1"; //难易度统一
        case "random_difflever":
          return "smartPagetwo2"; //难易度随机
      }
      // console.log(this.testinfomation);
      return "ss";
    },
    issmartbtnmode() {
      //计算编辑智能按钮的页面
      switch (this.testinfomation.PaperMode) {
        case "unified_db":
          return "Addtestscope"; //智能统一
        case "paper":
          return "Addtestscope"; //智能随机
        case "unified_difflever":
          return "Addtestscope"; //难易度统一
        case "random_difflever":
          return "Addtestscope"; //难易度随机
        case "unified_exam":
          return "Addexamtest"; //试卷统一
        case "sg_db":
          return "Addtestscope"; //精准手工
        case "unified_Proportion":
          return "Addtestscope"; //权重统一
      }
      // console.log(this.testinfomation);
      return "ss";
    },
    coms() {
      switch (this.isActive) {
        case 0:
          return "Pageone";
        case 1:
          return this.ismode; //智能组卷统一模式。
        case 2:
          return "Pagethree";
        case 2.2:
          return "ThreeSon";
        case 3:
          return "Pagefour";
        case 4:
          return this.issmartbtnmode;
        case 5:
          return "Addscore";
        case 6:
          return "Manualaddscore"; //手工填题按钮。
        case 7:
          return "HomePage";
        case 8:
          return this.paperinfomation[0].PaperMode == "unified_exam"
            ? "replaceExamData"
            : "replacetestdata";
        case 9:
          //权重新增返回
          return "smartPagetwo2";
        case 10:
          return "replaceExamData";
      }
      return "ss";
    },
    isstepone() {
      switch (this.isActive) {
        case 0:
          return true;
        case 1:
          return false;
        case 2:
          return false;
        case 3:
          return false;
      }
      return "sss";
    },
    issteptwo() {
      switch (this.isActive) {
        case 0:
          return true;
        case 1:
          return true;
        case 2:
          return false;
        case 3:
          return false;
      }
      return "sss";
    },
    isstepthree() {
      switch (this.isActive) {
        case 0:
          return true;
        case 1:
          return true;
        case 2:
          return true;
        case 3:
          return false;
      }
      return "sss";
    },
  },
  methods: {
    cutcoms(index) {
      this.isActive = index;
      if (index == 1) {
        this.isnewtestaas = 1;
      }
    },
    back() {
      this.$parent.cutcoms(0);
      // this.$parent.
      localStorage.removeItem("isreload");
      this.$destroy();
    },
    cutcomsfour(index) {
      this.isstepfour = index;
    },
    backpage() {
      this.$confirm(
        "试卷尚未修改保存完，退出后将不保存组卷信息，是否退出?",
        "温馨提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          let lxszRow = sessionStorage.getItem("lxszRow");
          // 此处判断是为了练习监控跳转查看编辑两种情况返回页面
          if (lxszRow !== null) {
            sessionStorage.removeItem("lxszRow");
            sessionStorage.removeItem("examState");
            this.$router.push("/practiceWatch");
          } else if (this.$route.query.trainId) {
            // 培训过来的
            this.$router.push({
              path: "manage",
              query: {
                trainId: this.$route.query.trainId,
              },
            });
          } else {
            this.$parent.cutcoms(0);
          }
          this.$destroy();
        })
        .catch(() => {});
    },
    Initialize() {
      console.log(this.paperinfomation);
      if (this.paperinfomation[0].PaperMode == "paper") {
        return;
      }
      //初始化智能随机的数据
      this.random_db_data.softApp = JSON.parse(
        this.paperinfomation[1].Config
      ).SoftApp;
      this.random_db_data.CookieApp = JSON.parse(
        this.paperinfomation[1].Config
      ).CookieCpt;
      // this.random_db_data.SelectedApp = JSON.parse(this.paperinfomation[1].Config).CookieCpt;
      if (this.paperinfomation[0].PaperMode == "random_Proportion") {
        //初始化权重随机的数据.
        this.random_Proportion_data.CookieApp = JSON.parse(
          this.paperinfomation[1].Config
        ).CookieApp;
        this.random_Proportion_data.CookieCpt = JSON.parse(
          this.paperinfomation[1].Config
        ).CookieCpt;
        this.random_Proportion_data.softApp = JSON.parse(
          this.paperinfomation[1].Config
        ).SoftApp;
        this.random_Proportion_data.DroitArr = JSON.parse(
          this.paperinfomation[1].Config
        ).DroitArr;
        this.random_Proportion_data.G_SlectedTestHt = JSON.parse(
          this.paperinfomation[1].Config
        ).G_SlectedTestHt;
        this.random_Proportion_data.tempSelectCptArray = JSON.parse(
          this.paperinfomation[1].Config
        ).tempSelectCptArray;
        this.random_Proportion_data.qzHTML = JSON.parse(
          this.paperinfomation[1].Config
        ).qzHTML;
      }
    },
    savemodifystyle() {
      //统一模式下的保存第三步数据
      let parms = {
        config: JSON.stringify({ Style: this.paper_data.config }),
        oldStyle: JSON.stringify({ Style: this.paper_data.oldStyle }),
        paperID: this.testinfomation.PaperID,
        guid: JSON.parse(localStorage.getItem("userlist")).guid,
        userID: JSON.parse(localStorage.getItem("userlist")).userID,
        hid: JSON.parse(localStorage.getItem("userlist")).hid,
      };
      editqusetionbank.savetongyi(qs.stringify(parms));
    },
  },
  async created() {
    console.log(this.testinfomation.PaperMode);
    this.testinfomation = this.$parent.$children[0].statePopupstatus;
    console.log(this.testinfomation);
    console.log(
      this.testinfomation.PaperMode == "unified_exam"
        ? "replaceExamData"
        : "replacetestdata"
    );
    let parms = {
      examID: this.testinfomation.ExamID || this.$route.query.typeId,
      guid: JSON.parse(localStorage.getItem("userlist")).guid,
      userID: JSON.parse(localStorage.getItem("userlist")).userID,
      hid: JSON.parse(localStorage.getItem("userlist")).hid,
    };
    console.log(this.testinfomation.ExamID, this.testinfomation, "ExamID");
    let res = await editqusetionbank.GetSavepaperList(parms);
    this.paperinfomation = res.data.Data; // 数据是编辑回显拿的
    //在这里初始化数据。
    this.Initialize();
    this.CookieCpt = JSON.parse(this.paperinfomation[1].Config).CookieCpt;
    this.SelectCpt = Object.values(
      JSON.parse(this.paperinfomation[1].Config).CookieCpt
    ).flat(2);
    this.Style["0"] = JSON.parse(this.paperinfomation[1].Config).Style[0];
  },
};
</script>

<style lang="scss" scoped>
.back {
  border-bottom: 1px solid #f8f8f8;
  padding: 10px 0px 9px 24px;
  background-color: #fff;
  i {
    display: inline-block;
    width: 12px;
    height: 12px;
    //  background-color: aqua;
    border-top: 2px solid #999999;
    border-left: 2px solid #999999;
    transform: scaleY(0.6) rotate(-45deg);
  }
  span {
    cursor: pointer;
    width: 47px;
    height: 25px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #999999;
  }
}
.stepcontent {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 88px;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  // border-radius: 20% !important;
  background-color: #fff;
}
.stepitem {
  height: 45px;
  background-color: #1890ff;
  border-radius: 45px 45px 45px 45px;
  overflow: hidden;
  position: relative;
  &:nth-child(1) {
    transform: translate(90px);
    z-index: 20;
    &::before {
      background-color: #1890ff;
    }
  }
  &:nth-child(2) {
    transform: translate(45px);
    z-index: 10;
  }
  &:nth-child(3) {
    //transform: translate(45px);
    z-index: 5;
  }
  &:nth-child(4) {
    transform: translate(-45px);
    z-index: 1;
  }
  &::before {
    display: inline-block;
    position: absolute;
    content: "";
    width: 60px;
    height: 60px;
    background-color: rgb(255, 255, 255);
    border-radius: 50% 50%;
    transform: translate(-8px, -7px);
  }
  span {
    display: inline-block;
    width: 100%;
    line-height: 45px;
    text-align: center;
    font-size: 16px;
    font-family: PingFang SC;
    // font-weight: bold;
    color: #ffffff;
    padding-left: 71px;
    padding-right: 71px;
  }
}
.konghuang {
  height: 24px;
  background-color: #f8f8f8;
}
.steptwo {
  background-color: #eeeeee;
  span {
    color: #bbbbbb !important;
  }
}
.fade-transform-leave-active,
.fade-transform-enter-active {
  transition: all 0.5s;
}

/*
enter定义进入过渡的开始状态
 */
.fade-transform-enter {
  opacity: 0;
  transform: translateX(-30px);
}
/*
leave-to离场动画结束后的状态
 */
.fade-transform-leave-to {
  opacity: 0;
  transform: translateX(30px);
}
</style>
